import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React, { useState } from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface BadgeSelectorProps {
  badges: {
    limited_spots: boolean;
    today_only: boolean;
    bonus_time: boolean;
    custom?: string;
  };
  onChange: (badges: any) => void;
  disabled?: boolean;
}

export function BadgeSelector({ badges, onChange, disabled }: BadgeSelectorProps) {
  useLanguage();
  const [customText, setCustomText] = useState(badges.custom || '');

  const handleCheckboxChange = (key: string, checked: boolean) => {
    onChange({ ...badges, [key]: checked });
  };

  const handleCustomChange = (value: string) => {
    const limited = value.slice(0, 22);
    setCustomText(limited);
    onChange({ ...badges, custom: limited || undefined });
  };

  return (
    <div className="space-y-4">
      <div className="space-y-3">
        <div className="flex items-center space-x-2">
          <Checkbox
            id="badge-limited"
            checked={badges.limited_spots}
            onCheckedChange={(checked) => handleCheckboxChange('limited_spots', checked as boolean)}
            disabled={disabled}
          />
          <Label
            htmlFor="badge-limited"
            className="text-sm font-normal cursor-pointer"
          >
            {translateInterfaceText("Vagas limitadas")}</Label>
        </div>

        <div className="flex items-center space-x-2">
          <Checkbox
            id="badge-today"
            checked={badges.today_only}
            onCheckedChange={(checked) => handleCheckboxChange('today_only', checked as boolean)}
            disabled={disabled}
          />
          <Label
            htmlFor="badge-today"
            className="text-sm font-normal cursor-pointer"
          >
            {translateInterfaceText("Somente hoje")}</Label>
        </div>

        <div className="flex items-center space-x-2">
          <Checkbox
            id="badge-bonus"
            checked={badges.bonus_time}
            onCheckedChange={(checked) => handleCheckboxChange('bonus_time', checked as boolean)}
            disabled={disabled}
          />
          <Label
            htmlFor="badge-bonus"
            className="text-sm font-normal cursor-pointer"
          >
            {translateInterfaceText("Bônus por tempo limitado")}</Label>
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="badge-custom" className="text-sm">
          {translateInterfaceText("Badge personalizado")}</Label>
        <div className="relative">
          <Input
            id="badge-custom"
            value={customText}
            onChange={(e) => handleCustomChange(e.target.value)}
            placeholder={translateInterfaceText("Ex: Última chance")}
            maxLength={22}
            disabled={disabled}
          />
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-muted-foreground">
            {customText.length}/22
          </span>
        </div>
      </div>
    </div>
  );
}
